<template>
    <div>
        <h6 class="mb-3 section-sub-title">WORK EXPERIENCE</h6>
        <div class="exp-card mb-5" v-for="item,index in data" :key="index">
            <div class="exp-card-header">
                <p class="exp-title">{{item.Company}} || {{item.Role}}</p>
                <p>{{item.Duration}}</p>
                <p>{{item.Location}}</p>
            </div>
            <div class="project-card-content">
                <ul>
                    <li v-for="activity,index in item.Activity" :key="index">
                        {{activity}}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
import {porfolioData} from '../service/index'
export default {
    name: 'Experience',
    data(){
        return{
            data: []
        }
    },
    beforeMount(){
        porfolioData()
        .then(response => {
            this.data = response.Work
            
        })
    }
}
</script>
<style scoped>
    .project-card-content ul li{
        list-style: disc;
    }
</style>